import { render, staticRenderFns } from "./titleChunk.vue?vue&type=template&id=5cd901bd&scoped=true"
import script from "./titleChunk.vue?vue&type=script&lang=js"
export * from "./titleChunk.vue?vue&type=script&lang=js"
import style0 from "./titleChunk.vue?vue&type=style&index=0&id=5cd901bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd901bd",
  null
  
)

export default component.exports